"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const index_1 = require("../../../index");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const ContentFeedCreateInput_1 = require("./ContentFeedCreateInput");
let ContentFeedUpdateInput = class ContentFeedUpdateInput extends ContentFeedCreateInput_1.ContentFeedCreateInput {
};
tslib_1.__decorate([
    type_graphql_1.Field(),
    class_validator_1.IsNotEmpty(),
    class_validator_1.IsIn(['json', 'xml']),
    tslib_1.__metadata("design:type", String)
], ContentFeedUpdateInput.prototype, "responseType", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.GraphQLJSON, { nullable: true }),
    class_validator_1.IsOptional(),
    class_validator_1.IsJSON({
        message: 'Must be valid JSON',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentFeedUpdateInput.prototype, "headers", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], ContentFeedUpdateInput.prototype, "useHeadersFromContentFeedId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], ContentFeedUpdateInput.prototype, "contentPushIndividualContentItems", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.Int),
    class_validator_1.Max(60 * 60),
    class_validator_1.Min(0),
    tslib_1.__metadata("design:type", Number)
], ContentFeedUpdateInput.prototype, "cacheLength", void 0);
ContentFeedUpdateInput = tslib_1.__decorate([
    type_graphql_1.InputType()
], ContentFeedUpdateInput);
exports.ContentFeedUpdateInput = ContentFeedUpdateInput;
//# sourceMappingURL=ContentFeedUpdateInput.js.map